export default {
  data() {
    return {
      hasBeenClosed: false,
      cookieNamePrefix: 'cookie_lifetime',
    }
  },

  watch: {
    identifier: {
      immediate: true,
      handler(value) {
        this.hasBeenClosed = this.hasBeenClosedInCookie(value)
      },
    },
  },

  methods: {
    getCookieName(identifier) {
      return `${this.cookieNamePrefix}_${identifier}_hide`
    },

    getCookieExpiration() {
      if (!this.cookieLifetime) return

      const msOneday = 1000 * 60 * 60 * 24
      const msLifetime = this.cookieLifetime * msOneday
      return new Date(new Date().getTime() + msLifetime)
    },

    writeCookie() {
      if (this.cookieLifetime === 0) return

      const cookieName = this.getCookieName(this.identifier)
      On.Cookie.write(cookieName, 'true', this.getCookieExpiration())
      this.hasBeenClosed = true
    },

    hasBeenClosedInCookie(identifier) {
      return On.Cookie.read(this.getCookieName(identifier)) == 'true'
    },
  },
}
